import { request } from '@umijs/max';

const TOKEN_KEY = 'erp_token';

export function saveToken(token?: string) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export async function getWecomLoginConfig() {
  return request<{ success: boolean; data: API.WecomLoginConfig }>(
    '/api/auth/wecom/config',
    { method: 'GET', skipErrorHandler: true },
  );
}

export async function getWecomOAuthUrl(redirectUri: string) {
  return request<{
    success: boolean;
    data: { url: string; scope: string };
  }>('/api/auth/wecom/oauth-url', {
    method: 'GET',
    params: { redirectUri },
    skipErrorHandler: true,
  });
}

export async function loginByWecom(body: API.WecomLoginParams) {
  return request<API.LoginResult>('/api/auth/wecom/login', {
    method: 'POST',
    data: body,
  });
}

export async function searchVerifyAccounts(name: string) {
  return request<{
    success: boolean;
    data: {
      list: Array<{
        id: string;
        name: string;
        username: string;
        department: string;
        channels: Array<'wecom' | 'email'>;
        hints: { wecom?: string; email?: string };
      }>;
    };
  }>('/api/auth/verify-code/accounts', {
    method: 'GET',
    params: { name },
    skipErrorHandler: true,
  });
}

export async function sendVerifyLoginCode(body: {
  userId: string;
  channel: 'wecom' | 'email';
}) {
  return request<{
    success: boolean;
    data: {
      ok: boolean;
      message: string;
      channel: string;
      hint: string;
      expiresInMinutes: number;
    };
  }>('/api/auth/verify-code/send', {
    method: 'POST',
    data: body,
  });
}

export async function loginByVerifyCode(body: {
  userId: string;
  code: string;
}) {
  return request<API.LoginResult>('/api/auth/verify-code/login', {
    method: 'POST',
    data: body,
  });
}

export async function sendEmailLoginCode(email: string) {
  return request<{
    success: boolean;
    data?: { ok: boolean; message: string; email: string };
  }>('/api/auth/email-code/send', {
    method: 'POST',
    data: { email },
  });
}

export async function loginByEmailCode(body: { email: string; code: string }) {
  return request<API.LoginResult>('/api/auth/email-code/login', {
    method: 'POST',
    data: body,
  });
}
